import React from "react";
import {connect} from "react-redux";
import Footer from "../components/Footer";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

const FooterContainer = () => {
    return (
        <div>
            <Footer />
        </div>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);


// WEBPACK FOOTER //
// ./src/container/FooterContainer.js